var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseService } from "./base.service";
export class ProductService extends BaseService {
    constructor(ellCommerce) {
        super(ellCommerce, "product");
    }
    getProductById(id, countryISO2) {
        return __awaiter(this, void 0, void 0, function* () {
            const iso2 = this.getCountryISO2(countryISO2);
            try {
                const response = yield this.api.request({
                    url: `products/${id}/country/${iso2}`,
                    method: "GET",
                });
                if (response.data) {
                    this.pushGtagEvent({ action: "select_item", products: [response.data], searchTerm: `${id}-${iso2}` });
                }
                return response.data;
            }
            catch (e) {
                this.handleError(e);
                return null;
            }
        });
    }
    getProductBySku(sku, countryISO2) {
        return __awaiter(this, void 0, void 0, function* () {
            const iso2 = this.getCountryISO2(countryISO2);
            try {
                const response = yield this.api.request({
                    url: `products/sku/${sku}/country/${iso2}`,
                    method: "GET",
                });
                if (response.data) {
                    this.pushGtagEvent({ action: "select_item", products: [response.data], searchTerm: `${sku}-${iso2}` });
                }
                return response.data;
            }
            catch (e) {
                this.handleError(e);
                return null;
            }
        });
    }
    getProducts(searchTerm, countryISO2) {
        return __awaiter(this, void 0, void 0, function* () {
            const iso2 = this.getCountryISO2(countryISO2);
            try {
                const response = yield this.api.request({
                    url: `products/country/${iso2}?search=${searchTerm}`,
                    method: "GET",
                });
                if (response.data) {
                    this.pushGtagEvent({ action: "view_item_list", products: response.data, searchTerm: `${searchTerm},${iso2}` });
                }
                return response.data;
            }
            catch (e) {
                this.handleError(e);
                return null;
            }
        });
    }
    getProductsUnauthenticated(searchTerm, countryISO2) {
        return __awaiter(this, void 0, void 0, function* () {
            const iso2 = this.getCountryISO2(countryISO2);
            const applicationId = this.getApplicationId();
            try {
                const response = yield this.api.request({
                    url: `products/application/${applicationId}/country/${iso2}?search=${searchTerm}`,
                    method: "GET",
                });
                if (response.data) {
                    this.pushGtagEvent({ action: "view_item_list", products: response.data, searchTerm: `${searchTerm}-${iso2}` });
                }
                return response.data;
            }
            catch (e) {
                this.handleError(e);
                return null;
            }
        });
    }
}
